import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { FaPaintRoller } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const MateriauxForm = ({ utilisateurId }) => {
  const MATERIAUX_CATEGORIE_ID = CATEGORIES.find(cat => cat.label === "Matériaux et outillage")?.id;

  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true);
  }, []);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    etat: "",
    typeMateriel: "",
    images: [],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      return updated;
    });
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, images: e.target.files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", MATERIAUX_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      if (key === "images") {
        for (let i = 0; i < formData.images.length; i++) {
          dataToSend.append("images", formData.images[i]);
        }
      } else {
        dataToSend.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          etat: "",
          typeMateriel: "",
          images: [],
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <FaPaintRoller />
        <h2>Créer une annonce pour du matériel :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />

        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />
          <label>FCFA</label>
        </div>

        <select
          name="typeMateriel"
          onChange={handleChange}
          value={formData.typeMateriel}
        >
          <option value="">Type de matériel</option>
          <option value="Peinture">Peinture</option>
          <option value="Menuiserie">Menuiserie</option>
          <option value="Electricité">Electricité</option>
          <option value="Plomberie">Plomberie</option>
          <option value="Quincaillerie">Quincaillerie</option>
          <option value="Extérieur">Extérieur</option>
          <option value="Sol/Mur">Sol/Mur</option>
          <option value="Luminaire">Luminaire</option>
          <option value="Autre">Autre</option>
        </select>

        <select name="etat" onChange={handleChange} value={formData.etat}>
          <option value="">État</option>
          <option value="Neuf">Neuf</option>
          <option value="Occasion">Occasion</option>
        </select>

        <input
          type="file"
          name="images"
          multiple
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        {errors.images && <span className="error">{errors.images}</span>}

        <button className="button" type="submit">
          Créer l'annonce
        </button>

        <span>Prix de l'annonce : 1000 Francs CFA</span>
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default MateriauxForm;
